import { List, Map } from 'immutable';
import * as actionTypes from './actionTypes';
import { createReducer } from 'utils/redux';
import { fromJS } from 'redux-little-router/lib/immutable/util/immutable';

const initialState = new Map({
  history: List(),
  loading: false,
  error: false,
  pagination: Map(),
});

function getData(content) {
  return fromJS(content);
}

function getPagination({ sort, number, size, totalPages, totalElements }) {
  return fromJS({
    sort,
    number,
    size,
    totalPages,
    totalElements,
  });
}

const onGetHistory = (state) => state.set('loading', true).set('error', null);

const onGetHistorySuccess = (state, { payload }) =>
  state
    .set('loading', false)
    .set('history', getData(payload))
    .set('pagination', getPagination(payload));

const onGetHistoryError = (state, { payload }) => state.set('loading', false).set('error', payload);

const onRemoveHistoryDeclaration = (state, { payload }) => {
  const history = state.get('history').filter((el) => {
    return el.get('cardId') !== payload;
  });
  return state.set('history', history);
};

export default createReducer(initialState, {
  [actionTypes.GET_HISTORY]: onGetHistory,
  [actionTypes.GET_HISTORY_SUCCESS]: onGetHistorySuccess,
  [actionTypes.GET_HISTORY_FAILURE]: onGetHistoryError,
  [actionTypes.REMOVE_HISTORY_DECLARATION]: onRemoveHistoryDeclaration,
});
